<template>
    <div>
<!--body content start-->

<div id="main-page" class="page-content">

<section>
  <div class="container">
    <div class="table-responsive">
      <table class="cart-table table">
        <thead>
          <tr>
            <th scope="col">Product</th>
            <th scope="col">Price</th>
            <th scope="col">Quantity</th>
            <th scope="col">Remove</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="media">
                <div class="d-flex">
                  <a href="#">
                    <img class="img-fluid box-shadow" src="images/product-thumb/01.jpg" alt="">
                  </a>
                </div>
                <div class="media-body">
                  <p>Women's Fashion</p>
                </div>
              </div>
            </td>
            <td>
              <h5>$132.00</h5>
            </td>
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <button class="btn-product btn-product-up"> <i class="fas fa-minus"></i>
                </button>
                <input class="form-product" type="number" name="form-product" value="1">
                <button class="btn-product btn-product-down"> <i class="fas fa-plus"></i>
                </button>
              </div>
            </td>
            <td>
              <button type="submit" class="btn-delet"><i class="far fa-trash-alt"></i>
              </button>
            </td>
            <td>
              <h5>$132.00</h5>
            </td>
          </tr>
          <tr>
            <td>
              <div class="media">
                <div class="d-flex">
                  <a href="#">
                    <img class="img-fluid box-shadow" src="images/product-thumb/02.jpg" alt="">
                  </a>
                </div>
                <div class="media-body">
                  <p>Watch</p>
                </div>
              </div>
            </td>
            <td>
              <h5>$28.00</h5>
            </td>
            <td>
              <div class="d-flex justify-content-center align-items-center">
                <button class="btn-product btn-product-up"> <i class="fas fa-minus"></i>
                </button>
                <input class="form-product" type="number" name="form-product" value="1">
                <button class="btn-product btn-product-down"> <i class="fas fa-plus"></i>
                </button>
              </div>
            </td>
            <td>
              <button type="submit" class="btn-delet"><i class="far fa-trash-alt"></i>
              </button>
            </td>
            <td>
              <h5>$28.00</h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt-5">
      <div class="col"> <a class="btn btn-theme" href="#">Update Cart</a>
      </div>
      <div class="col text-md-left"> <a class="btn btn-theme" href="#">Close Coupon</a>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-left">
        <div>
          <ul class="list-unstyled">
            <li class="mb-2"><span> Sub Total : </span> $ 160.00</li>
            <li class="mb-2"><span> VAT (20%) : </span> $ 20.00</li>
            <li><span><strong class="cart-total"> Total :</strong></span>  <strong class="cart-total">$ 180.00 </strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row justify-content-end mt-5">
      <div class="col text-md-left"> <a class="btn btn-white" href="#">Continue Shopping</a>
        <a class="btn btn-theme" href="product-checkout.html">Proceed to checkout</a>
      </div>
    </div>
  </div>
</section>

</div>

<!--body content end--> 
    </div>
</template>

<script>

export default {
    data: function () {
        return {
            name: 'Product Checkout'
        }
    },
};
</script>